<template>
  <div class="text-input-container">
    <div
      ref="input"
      class="textarea"
      contenteditable="true"
      :placeholder="placeholder"
      v-show="allowWrap"
      v-html="value"
      @blur="blur"
      @focus="handleFocus"
      @input="input"
      @click="handleClickInput"
    >
      <br />
    </div>
    <input
      v-show="!allowWrap"
      ref="input2"
      :placeholder="placeholder"
      @input="handleKeyUp"
      @blur="blur"
      @focus="handleFocus"
      :maxlength="allowLength"
      :readonly="readonly"
      @click="handleClickInput"
    />
    <div class="info-prompt" v-if="requiredPrompt && showPrompt">
      <div class="icon"></div>
      {{ promptText }}
    </div>
  </div>
</template>

<script>
import MonitorKeyboard from '@utils/keyBoard';

export default _extend({
  name: 'TextInput',
  data() {
    return {
      inputValue: '',
      showPrompt: false,
      monitorKeyboard: null
    };
  },
  props: {
    field: {
      type: String
    },
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    allowLength: {
      type: Number,
      default: 30
    },
    allowWrap: {
      type: Boolean,
      default: false
    },
    requiredPrompt: {
      type: Boolean,
      default: false
    },
    promptText: {
      type: String,
      default: ''
    },
    trim: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    blur(e) {
      // 提交内容
      setTimeout(() => {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 300);
      //  详细地址 是div e.target.value 是 undefined  区分下
      let value =
        e.target.localName === 'div' ? e.target.innerText : e.target.value;
      if (this.trim) {
        value = value ? value.trim() : value;
      }
      this.showPrompt = value.length < 2;
      this.$emit('blur');
    },
    handleFocus() {
      this.showPrompt = false;
    },
    input(e) {
      // 输入内容变化时，触发
      if (this.stringLen(e.target.innerText) <= this.allowLength) {
        this.inputValue = e.target.innerText;
        this.$emit('update', e.target.innerText);
      } else {
        e.target.innerText = this.inputValue;
        this.setFocus();
      }
    },
    handleKeyUp(e) {
      // let value = e.target.value.replace(/[^\u4e00-\u9fa5]/g, '');
      // e.target.value = value;
      let value = e.target.value;
      if (this.trim) {
        value = value ? value.trim() : value;
      }
      this.$emit('update', value);
    },
    setFocus() {
      const el = this.$refs.input;
      el.focus();
      let range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      let sel = window.getSelection();
      // 判断光标位置，如不需要可删除
      if (sel.anchorOffset !== 0) {
        return;
      }
      sel.removeAllRanges();
      sel.addRange(range);
    },
    stringLen(str) {
      let realLength = 0;
      let len = str.length;
      let charCode = -1;
      for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) {
          realLength += 0.5;
        } else {
          realLength += 1;
        }
      }
      return realLength;
    },
    getKeyboardState() {
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听模拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {
        // console.log('键盘弹出');
      });

      // 监听键盘收起事件
      this.monitorKeyboard.onHidden(() => {
        this.$refs.input.blur();
        this.$refs.input2.blur();
      });
    },
    handleClickInput(e) {
      this.$emit('click', e);
    }
  },
  watch: {
    showPrompt(val) {
      this.$emit('updateError', this.field, val);
    },
    value(val) {
      this.$refs.input2.value = val;
      this.showPrompt = val.length < 2;
    }
  },
  mounted() {
    this.$refs.input.innerText = this.value;
    this.$refs.input2.value = this.value;
    this.getKeyboardState();
  },
  beforeDestroy() {
    this.monitorKeyboard.onEnd();
  }
});
</script>

<style lang="scss" scoped>
@import './TextInput.scss';
</style>



// WEBPACK FOOTER //
// src/business/views/ActiveForm/TextInput/TextInput.vue